import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import * as formatter from 'mt-react-common/utils/formatter';
import SpecialPagesViewContainer from 'components/SpecialPages/containers/SpecialPagesViewContainer';
import NotFound from 'components/Common/NotFound';

import SpecPagesTags from '../Common/SpecPagesTags';

const SpecPagesView = props => {
  if (props.requestState.lastStatusCode === 404) {
    return (
      <div className="container">
        <NotFound />
      </div>
    );
  }
  if (props.requestState.requestInProcess || !props.item) {
    return <MediumPreLoader />;
  }
  return (
    <article className="panel panel-default container">
      <Helmet>
        <title>{props.item.metaTitle}</title>
        <meta name="description" content={props.item.metaDescription} />
        <meta name="keywords" content={props.item.metaKeywords} />
      </Helmet>
      <div className="panel-body">
        <div className="paper">
          <header>
            <h1>{props.item.title}</h1>
            <p className="lead">{props.item.title2}</p>
            <div className="meta">
              {formatter.dateFormat7(props.item.createdAt)}
              {props.item.pageTags && props.item.pageTags.length > 0 ? (
                <React.Fragment>
                  {'· '}
                  <SpecPagesTags pageTags={props.item.pageTags} />
                </React.Fragment>
              ) : null}
            </div>
          </header>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.item.content }}
          />
        </div>
      </div>
    </article>
  );
};

SpecPagesView.defaultProps = {
  item: null
};

SpecPagesView.propTypes = {
  // CONNECT STATES
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    title2: PropTypes.string.isRequired,
    seo_url: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    metaKeywords: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    pageTags: PropTypes.arrayOf(PropTypes.shape).isRequired
  })
};

export default SpecialPagesViewContainer(SpecPagesView);



// WEBPACK FOOTER //
// ./src/components/SpecialPages/SpecPagesView/SpecPagesView.js